import type { Command } from 'commander';
import { existsSync, writeFileSync } from 'node:fs';
import { buildTemplate } from '@wport/core';
import { InvalidArgumentError } from '../../../lib/errors';
import { printJson } from '../../../lib/output';

interface TemplateFlags {
	out?: string;
}

/**
 * `resumes template` 核心：離線命令,不發請求、不需登入,依 SECTIONS 產出範例骨架(buildTemplate())。
 * 沒有 `--out` → 印到 stdout(同 schema 命令慣例,永遠 JSON,不看 --output table/json);
 * 有 `--out` → 寫入該路徑,檔案已存在則拒絕覆蓋(exit 2)而非靜默蓋掉使用者現有內容。
 */
export function runResumesTemplate(outPath?: string): void {
	const template = buildTemplate();

	if (outPath === undefined) {
		printJson(template);
		return;
	}

	if (existsSync(outPath)) {
		throw new InvalidArgumentError(`File already exists: ${outPath} (refusing to overwrite — remove it or choose a different --out path)`);
	}

	try {
		writeFileSync(outPath, `${JSON.stringify(template, null, 2)}\n`, 'utf8');
	} catch (err) {
		throw new InvalidArgumentError(`Failed to write template to ${outPath}: ${(err as NodeJS.ErrnoException).message}`);
	}

	process.stdout.write(`Wrote template to ${outPath}\n`);
}

export function registerPersonalResumesTemplate(parent: Command): void {
	parent
		.command('template')
		.description('Print (or write) a resume aggregate skeleton with example values for every field (offline, no login required)')
		.option('--out <file>', 'write the template to this file instead of stdout (fails if the file already exists)')
		.action((flags: TemplateFlags) => {
			runResumesTemplate(flags.out);
		});
}
